import React from 'react';

import { Menu } from '@wds/menu';

import PropTypes from 'prop-types';

const {
	DownloadModal,
} = require('sma.common/downloads');
const modals = require('sma.common/components/modals');

const ajax = require('sma.common/ajax');

export default class ApplicationCardMenu extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			application: props.application,
			menuItems: props.items,
			show: false,
		};
	}

	handleOnClick = (event) => {
		const action = event.currentTarget.getAttribute('action');
		if (action === 'download') {
			this.handleDownload();
		} else if (action === 'preview') {
			this.handlePreview();
		} else if (action === 'delete') {
			this.handleDelete();
		}
		this.setState({ show: false });
	}

	handleDownload = () => {
		const {
			application,
		} = this.state;

		const modal = new DownloadModal({
			submission_ids: [application.id],
		});
	}

	handlePreview = () => {
		const {
			application,
		} = this.state;
		window.location.href = reverse('application-submit-preview', { app_id: application.id });
	}

	handleDelete = () => {
		const {
			application,
		} = this.state;
		if (application.can_delete) {
			const modal = new modals.Confirm(
				gettext('Delete your application'),
				gettext("Are you sure you want to delete your application? You won't be able to undo this action."),
				() => {
					ajax.post({
						url: reverse('application-delete', { app_id: application.id }),
						callback: () => {
							window.location.reload();
						},
					});
				},
			);
		}
	}

	render() {
		const {
			menuItems,
			show,
		} = this.state;
		return (
			<React.Fragment>
				<div className="application-menu">
					<Menu
						placement="bottom-right"
						menuTrigger={(
							<div
								className="wds-p-3"
								role="button"
								aria-label="Open action menu"
								tabIndex="0"
								aria-haspopup="menu"
								aria-expanded={show} // Use the 'show' state to toggle aria-expanded
							>
								<i className="nc-icon-mini ui-2_menu-dots" aria-hidden="true" />
							</div>
						)}
						onChange={() => { this.setState({ show: !show })}}
						show={show}
						autoClose
						noRules
						dense
					>
						{ menuItems.map((menuItem) => {
							const {
								action,
								label,
							} = menuItem;
							return (
								<Menu.Item key={action} action={action} onClick={this.handleOnClick}>{label}</Menu.Item>
							);
						}) }
					</Menu>
				</div>
			</React.Fragment>
		);
	}
}

ApplicationCardMenu.propTypes = {
	application: PropTypes.shape().isRequired,
	items: PropTypes.arrayOf(PropTypes.shape({
		action: PropTypes.string.isRequired,
		label: PropTypes.string.isRequired,
	})).isRequired,
};
